import React, { createContext, useContext, useMemo } from 'react';

import type { LuminaViewEndedHandler } from './view-ended';

type LuminaViewEndedContextValue = {
	layoutIndex: number;
	onViewEnded?: LuminaViewEndedHandler;
	sessionId?: string;
};

const LuminaViewEndedContext = createContext<LuminaViewEndedContextValue>({ layoutIndex: 0 });

export const LuminaViewEndedProvider = ({
	children,
	layoutIndex = 0,
	onViewEnded,
	sessionId,
}: Omit<LuminaViewEndedContextValue, 'layoutIndex'> & {
	children: React.ReactNode;
	layoutIndex?: number;
}): React.JSX.Element => {
	const value = useMemo(
		() => ({ layoutIndex, onViewEnded, sessionId }),
		[layoutIndex, onViewEnded, sessionId],
	);

	return (
		<LuminaViewEndedContext.Provider value={value}>{children}</LuminaViewEndedContext.Provider>
	);
};

export const useLuminaViewEndedContext = (): LuminaViewEndedContextValue =>
	useContext(LuminaViewEndedContext);
